module.exports = __webpack_public_path__ + "static/img/4.cefbf4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/4.jpg
// module id = MYRP
// module chunks = 0